<div
  *ngIf="mainLabel || showLabel"
  class="sidebar-menu-item"
  [class.is-active]="isCurrentRoute"
  (click)="onClick()"
  [routerLink]="route || null"
  routerLinkActive="is-active"
  [routerLinkActiveOptions]="{ exact: false }">

  <!-- Icon container -->
  <div class="menu-item-icon-wrap">
    <img class="menu-item-icon" [src]="icon" [alt]="label" />
  </div>

  <!-- Label -->
  <span class="menu-item-label">{{ label | translate }}</span>

  <!-- Arrow -->
  <div class="menu-item-arrow">
    <nb-icon *ngIf="!isArabic" icon="chevron-right-outline"></nb-icon>
    <nb-icon *ngIf="isArabic" icon="chevron-left-outline"></nb-icon>
  </div>

  <!-- Active indicator -->
  <div class="menu-item-active-bar"></div>
</div>
